import {Component, Input} from '@angular/core';

@Component({
  selector: 'gn-camera',
  template: `
    <video width="100%" height="100%" [srcObject]="stream" [autoplay]="autoplay"></video>
  `
})
export class GnCameraComponent {

  @Input() videoId: string;
  @Input() audioId: string;
  @Input() autoplay = true;

  stream: MediaStream;

  open(): void {
    navigator.mediaDevices.getUserMedia({
      video: {deviceId: this.videoId},
      audio: {deviceId: this.audioId}
    })
      .then(stream => {
        this.stream = stream;
      });
  }

  close(): void {
    if (this.stream) {
      this.stream.getTracks().forEach(track => {
        track.stop();
      });
      this.stream = null;
    }
  }

}
